import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  disabled: {
    color: '#B9B9B9',
  },
  icon: {
    fill: '#B9B9B9',
  },
  linkButton: {
    textTransform: 'capitalize',
  },
  menuItemRow: {
    height: '100%',
    alignItems: 'center',
    '& #text': {
      paddingLeft: '10px',
    },
    '& #icon': {
      paddingTop: '3px',
    },
  },
  greenText: {
    color: 'green',
  },
  redText: {
    color: 'red',
  },
  filtersContainer: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0 1px 5px 0 rgba(227, 227, 236, 0.8)',
    padding: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  filterContainerTitleText: {
    color: theme.palette.captGrey.main,
  },
}))
